module.exports = __webpack_public_path__ + "img/homeScreenRe1.7af842f7.svg";